import { fromJS } from "immutable";

const initWithoutRtvData = fromJS({});

const initGetInvoiceData = {
  settingName: "",
  settingValue: "",
};

const initFilterDataRtv = fromJS({
  invoiceNo: "",
  plantCode: "",
  customerCode: "",
  customerName: "",
  batch: "",
  materialCode: "",
  materialDescription: "",
  pageNo: 1,
  pageSize: 35,
});

export function filterDataRtv(state = initFilterDataRtv, action) {
  switch (action.type) {
    case "FILTER_SET_INVOICE_NO_SUCCESS":
      return state.set("invoiceNo", action.invoiceNo);
    case "FILTER_SET_PLANT_CODE_SUCCESS":
      return state.set("plantCode", action.plantCode);
    case "FILTER_SET_CUSTOMER_CODE_SUCCESS":
      return state.set("customerCode", action.customerCode);
    case "FILTER_SET_CUSTOMER_NAME_SUCCESS":
      return state.set("customerName", action.customerName);
    case "FILTER_SET_BATCH_SUCCESS":
      return state.set("batch", action.batch);
    case "FILTER_SET_MATERIAL_CODE_SUCCESS":
      return state.set("materialCode", action.materialCode);
    case "FILTER_SET_MATERIAL_DESCRIPTION_SUCCESS":
      return state.set("materialDescription", action.materialDescription);
    case "FILTER_SET_PAGE_NO_SUCCESS":
      return state.set("pageNo", action.pageNo);
    case "FILTER_SET_PAGE_SIZE_SUCCESS":
      return state.set("pageSize", action.pageSize);
    default:
      return state;
  }
}

export function withoutRtvData(state = initWithoutRtvData, action) {
  switch (action.type) {
    case "WITHOUT_RTV_FETCH_DATA_SUCCESS":
      return fromJS(action.dataWithoutRtv);
    default:
      return state;
  }
}

export function getInvoiceData(state = initGetInvoiceData, action) {
  switch (action.type) {
    case "SETTING_GET_DATA_SUCCESS":
      return action.dataGetSetting;
    case "SETTING_ADD_SETTING_NAME_SUCCESS":
      return state.set("settingName", action.settingName);
    case "SETTING_ADD_SETTING_VALUE_SUCCESS":
      return state.set("settingValue", action.settingValue);
    default:
      return state;
  }
}

export function nonMTKADetails(state = fromJS([]), action) {
  switch (action.type) {
    case "NON_MTKA_DETAILS_FETCH":
      return fromJS(action.detail);
    default:
      return state;
  }
}

export function nonMTKADetailsTemp(state = fromJS([]), action) {
  switch (action.type) {
    case "NON_MTKA_DETAILS_FETCH_TEMP":
      return fromJS(action.detail);
    default:
      return state;
  }
}


export function nonMTKAFrom(state = '', action) {
  switch (action.type) {
    case "NON_MTKA_FROM_PAGE":
      return action.page;
    default:
      return state;
  }
}
